import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=616509f1"
import script from "./Properties.vue?vue&type=script&lang=js"
export * from "./Properties.vue?vue&type=script&lang=js"
import style0 from "./Properties.vue?vue&type=style&index=0&id=616509f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports